import Button from 'components/_parts/atoms/button';
import CustomTable from 'components/_parts/atoms/table';
import LoadingCustom from 'components/layouts/loading/loading';
import dayjs from 'dayjs';
import { useOuterClick } from 'providers/OutsideClick';
import { useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { HIT_FTE_LIMIT_MOVE_ORDER } from 'redux/actions/company';
import styled from 'styled-components';
import { useFteLimitMoveOrderMutation } from 'components/company/hooks/useCompany';
import ModalLimitFte from '../modal';
import status from './status';


interface PropsType {
  t : (key:string) => string
}

const ButtonMod = styled(Button)`
  width: 100%;
  width: 92px;
  height: 40px;
  float: right;
`;
const ButtonEdit = styled(Button)`
  width: 100%;
  max-width: 70px;
  height: 24px;
  float: right;
`;

const CustomTableMod = styled.div`
  [data-column-id="1"] {
    min-width: 5px;
    tex-align: left;
  }
  [data-column-id="2"] {
    tex-align: left;
  }
  [data-column-id="3"] {
    justify-content: center;
  }
  [data-column-id="4"] {
    min-width: 50px;
    width: 100%;
    padding: 0px 5px 0px 0px;
  }
  [data-column-id="5"] {
    min-width: 80px;
    justify-content: center;
    padding: 0px 5px 0px 0px;
  }
  [data-column-id="7"] {
    display: flex;
    justify-content: center;
    flex-grow: 0; 
    padding: 2px;
  }
  .rdt_TableBody {
    height: 500px;
    overflow: auto;
  }
`;

const customStyles = {
  headCells: {
    style: {
      fontSize: '12px',
      fontWeight: 'bold',
      textAlign: 'center',
      fontFamily: 'Quicksand',
      padding: '0px',
      justifyContent: 'start',
    },
  },
  cells: {
    style: {
      padding: '0px',
      justifyContent: 'start',
    },
  },
  rows: {
    style: {
      fontFamily: 'Quicksand',
      minHeight: '35px', // override the row height
      borderRadius: 0,
      filter: 'none',
      borderBottom: 'unset !important',
      marginBottom: '0px',
    },
  },
};

function Index(props: PropsType) {
  const { t } = props;
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [id, setId] = useState(null);
  const [dataEdit, setDataEdit] = useState(null);
  const [typeForm, setTypeForm] = useState('');
  const fteLimitMoveOrderMutation = useFteLimitMoveOrderMutation();
  const { fte, keyFTELimit } = useSelector((state) => ({
    fte: state?.wla?.list_fte,
    keyFTELimit: state?.loading?.listKey?.companyFTEClassification,
  }));

  const innerRef = useOuterClick((e) => {
    if (
      e?.srcElement?.className && (e.srcElement?.className === 'modal fade show'
            || e.srcElement?.className?.includes('cs_modal-bg'))
    ) {
      setShowModal(false);
      setId(null);
    }
  });

  const handleOrdering = (id:string, type: string) => {
    const dataPayload = {
      wla_fte_limit_id: id,
      type,
    };
    fteLimitMoveOrderMutation.mutate({
      data: dataPayload,
    });
  };

  const actionTable = ({ row, i }) => (
    <>
      <Button
        style={{
          width: '26px',
          height: '25px',
          marginRight: '3px',
        }}
        icon="next"
        func={() => handleOrdering(row.wla_fte_limit_id, 'move_up')}
      />
      <Button
        style={{
          width: '26px',
          height: '25px',
          marginRight: '10px',
        }}
        icon="prev"
        func={() => handleOrdering(row.wla_fte_limit_id, 'move_down')}
      />
      <ButtonEdit
        icon="edit"
        func={() => {
          setShowModal(true);
          setTypeForm('update');
          setId(i);
          setDataEdit(row);
        }}
      >
            &nbsp;&nbsp;
        {t('org.structure_view.modal.edit')}
      </ButtonEdit>
    </>
  );

  const columns = [
    {
      name: 'No',
      sortField: true,
      selector: (_, i) => i + 1,
      cellStyle: { verticalAlign: 'middle' },
      width: '4%',
    },
    {
      name: t('company.name'),
      sortField: true,
      selector: (row) => row.name,
      width: '18%',
    },
    {
      name: t('company.order'),
      sortField: true,
      selector: (row) => row.order,
      width: '8%',
    },
    {
      name: t('company.status'),
      sortField: true,
      selector: (row) => status(row.is_anomaly),
      width: '14%',
    },
    {
      name: t('org.index_view.last_update'),
      sortField: true,
      selector: (row) => dayjs(row.created_at).format('D MMM YYYY') ?? '-',
      center: true,
      width: '14%',
    },
    {
      name: t('wla.status.table.created_by'),
      sortField: true,
      selector: (row) => row.member?.name ?? '-',
      center: true,
      width: '15%',
    },
    {
      name: t('org.employee.action'),
      sortField: true,
      width: '23%',
      style: {
        display: 'flex',
        justifyContent: 'flex-end',
      },
      cell: (row, i) => (
        actionTable({ row, i })
      ),
    },
  ];

  return (
    <>
      {showModal && (
      <ModalLimitFte
        innerRef={innerRef}
        modal={showModal}
        funcModal={setShowModal}
        ids={id}
        dataLimitFTE={dataEdit}
        funcId={() => setId}
        typeForm={typeForm}
        t={t}
      />
      )}
      <div
        className="tab-pane active position-relative"
        id="fte_list"
        role="tabpanel"
        style={{
          minHeight: '700px',
        }}
      >
        { keyFTELimit ? <LoadingCustom style={{ height: '100px' }} /> : (
          <>
            <div className="row">
              <div className="col-8">
                <h4 className="title">{t('company.fte_limit')}</h4>
              </div>
              <div className="col-4">
                <ButtonMod
                  icon="create"
                  func={() => {
                    setShowModal(true);
                    setTypeForm('create');
                  }}
                >
                &nbsp;&nbsp;
                  {t('board.add')}
                </ButtonMod>
              </div>
            </div>
            <CustomTableMod>
              <CustomTable
                columns={columns}
                data={fte}
                customStyles={customStyles}
              />
            </CustomTableMod>
          </>
        )}
      </div>
    </>
  );
}

export default Index;
